<template>
    <span>
        <span v-if="nickName && !hideName" style="margin-right:4px;">{{ nickName }}</span>
        <a @click="showFullMobile" v-if="!fullMobile" style="color: red;margin-right:4px;" title="点击显示手机号">
            {{ mobile.indexOf('DU:') != -1 ? '钉钉用户' : mobile }}
        </a>
        <span v-else style="margin-right:4px;">{{ fullMobile }}</span>
    </span>
</template>

<script>
import student from '../../api/student'
export default {
    data() {
        return {
            fullMobile: ''
        }
    },
    props: {
        id: {
            required: true,
            type: Number
        },
        nickName: {
            required: true,
            type: String
        },
        mobile: {
            required: true,
            type: String
        },
        hideName: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        showFullMobile() {
            let params = {
                studentId: this.id,
                parentNick: this.nickName,
                mobile: this.mobile
            }
            student.getMobile(params).then(res => {
                if (res.code == 0) {
                    this.fullMobile = res.mobile
                } else {
                    this.$message.error(res.msg + "获取明文手机号失败，可能家长信息已改变，请重新查询学生信息并再次获取手机号")
                }
            })
        }
    }
}
</script>
<style></style>